import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { TagsAdminState } from "./types";
import { setResponseMessage } from "../adminSlice";

const initialState: TagsAdminState = {
  options: [],
  tags: [],
  tag: undefined,
  loading: false,
};

const tagsAdmin = createSlice({
  name: "tagsAdminSlice",
  initialState,
  reducers: {
    setTagForEdit(state, action) {
      state.tag = action.payload;
      state.loading = false;
    },
    setOptions(state, action) {
      state.options = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setTags(state, action) {
      state.tags = action.payload;
    },
  },
});
export const {
  setLoading,
  setOptions,
  setTags,
  setTagForEdit,
} = tagsAdmin.actions;

export const selectLoading = (state: RootState) => state.tagsAdmin.loading;

export const selectAllTags = (state: RootState) => state.tagsAdmin.tags;

export const selectTagForEditing = (state: RootState) => state.tagsAdmin.tag;
export const fetchAllTags = () => async (dispatch: any) => {
  try {
    const result = await axios.get(`${API_URL}/admin/tags`);
    dispatch(setTags(result.data.data));
  } catch (error: any) {
    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addTag = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);
    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/admin/tags`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно качихте тага.",
          hasError: false,
        })
      );
      dispatch(setLoading(false));

      dispatch(fetchAllTags());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const updateTag = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data.data);

    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/tags/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно променихте тага.",
          hasError: false,
        })
      );
      dispatch(fetchAllTags());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const deleteTag = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/admin/tags/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте тага.",
          hasError: false,
        })
      );
      dispatch(fetchAllTags());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const fetchTag = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    let token = userStorage.getUser();
    const result = await axios.get(`${API_URL}/admin/tag-values/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setTagForEdit(result.data.data));
  } catch (error: any) {
    batch(() => {
      dispatch(setLoading(false));
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
    });
  }
};

export default tagsAdmin.reducer;
